import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'reactstrap';
import PropTypes from 'prop-types';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { t } from '../common/Translate';
import plus_icon from '../../assets/img/plus_icon.svg';
import minus_icon from '../../assets/img/minus_icon.svg';

const TooltipComponent = ({
  handleShowContent,
  handleToggle,
  title,
  tooltipOpen,
  info,
  target,
  toggle,
  collapse,
  dataTestid,
}) => {
  return (
    <>
      <div
        className="calendar-meeting-folder-section active d-flex justify-content-between mb-3"
        role="button"
        tabIndex="0"
        onClick={toggle}
        onKeyDown={toggle}
        data-testid={dataTestid}
      >
        <div>
          <div>
            <FontAwesomeIcon
              icon={faInfoCircle}
              size="1x"
              id={`toolTip${target}`}
              className="info-icon position-absolute ml-n2 mt-1"
              onClick={handleShowContent}
            />
            <Tooltip placement="bottom" isOpen={tooltipOpen} target={`toolTip${target}`} toggle={handleToggle}>
              {t(`${title}`)}
            </Tooltip>
          </div>
          <div className="ml-3 text-primary font-weight-bold">{info}</div>
        </div>
        <div>{collapse ? <img src={minus_icon} alt="minus" /> : <img src={plus_icon} alt="plus" />}</div>
      </div>
    </>
  );
};

TooltipComponent.propTypes = {
  tooltipOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  handleShowContent: PropTypes.func.isRequired,
  handleToggle: PropTypes.func.isRequired,
  info: PropTypes.string.isRequired,
  toggle: PropTypes.func.isRequired,
  collapse: PropTypes.bool.isRequired,
  dataTestid: PropTypes.string.isRequired,
};
export default TooltipComponent;
